import React from 'react';
import { Logo, LogoType } from '@design-system';

export const NavBar = ({
  logo,
  setIsOpen,
}) => {
  return (
    <>
      {/* Navbar Mobile - El desktop ya no necesita navbar, todo está en el sidebar */}
      <header className="sticky top-0 z-10 flex w-full items-center justify-between border-b-4 bg-black px-6 py-4 lg:hidden">
        <div className="relative w-full">
          <button
            onClick={() => setIsOpen(true)}
            className="text-white focus:outline-none lg:hidden"
          >
            <svg
              className="h-6 w-6"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 6H20M4 12H20M4 18H11"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            {/* Brand */}
            <Logo wLogo={logo} type={LogoType.white} width={'125px'} />
          </div>
        </div>
      </header>
    </>
  );
};
